import { render } from "./update-sponsor.vue?vue&type=template&id=c586b516&scoped=true&ts=true"
import script from "./update-sponsor.vue?vue&type=script&lang=ts"
export * from "./update-sponsor.vue?vue&type=script&lang=ts"

import "./update-sponsor.vue?vue&type=style&index=0&id=c586b516&scoped=true&lang=scss"

import exportComponent from "/Applications/MAMP/htdocs/wrf.com/wrf-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c586b516"]])

export default __exports__